import React from 'react';
import IntegrationCard from './IntegrationCard';
import EmptyPlaceholder from './EmptyPlaceholder';

const IntegrationBoard = ({ integrations, emptyText, isDeferred }) => {
  if (!integrations?.length) {
    return <EmptyPlaceholder text={emptyText} />;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fill,minmax(340px,1fr))] gap-5">
      {integrations?.map((item) => {
        return <IntegrationCard key={item?.id} data={item} isDeferred={isDeferred} />;
      })}
    </div>
  );
};

export default IntegrationBoard;
